import styled, { css } from "styled-components"

const textStyles = css`
  font-family: ${({ theme }) => theme.font.family.body};
  font-size: ${({ theme }) => theme.font.size.s};
  line-height: 1.71;
  color: ${({ theme }) => theme.color.secondary01};
  white-space: pre-wrap;
  word-break: break-word;
`

const StyledWrapper = styled.div`
  a {
    ${textStyles}
    font-weight: ${({ theme }) => theme.font.weight.bold};
    text-decoration: underline;
  }

   p {
    ${textStyles}
  }

  > ul,
  ol {
    margin: 2rem 0;
    > li {
      ${textStyles}
    }
  }

  ${({ customStyles }) => customStyles};
`

export { StyledWrapper }
